import React, { useCallback } from 'react';
import { CardData, CardProps, DigitalWallet } from '..';
import CardFactory from '../card-factory';
import Terms from '../components/terms';
import Button from '../../../../../../hoc/components/button';
import { ServiceNames } from '../../../../../../hoc/constants/service.constants';
import { PrintIcon } from '../../../../../../../assets/images/print-icon';
import {
	EventCategory,
	EventLabel,
} from '../../../../../../../services/analytics';
import { navigate } from 'gatsby';
import { EventType } from '../../../../../../../services/analytics-interfaces';
import Section from '../../../../../../hoc/components/section/section';
import { UserActionType } from '../../../../../../hoc/components/analytics';
import useTranslation from '../../../../../../../hooks/useTranslation';

const CardConfirmed: React.FC<CardProps> = ({ service, data, printMode }) => {
	const { t } = useTranslation();

	const onPrint = useCallback(() => {
		window.print();
	}, []);

	const openPrint = useCallback(() => {
		navigate('print/' + service.name, {
			state: { data: data, service: service },
		});
	}, [data, service]);
	return (
		<Section
			title={t(`pages.confirmation.service.${service.name}.title`)}
			description={t(`pages.confirmation.service.${service.name}.description`)}
			descriptionClassName="text-lg text-left md:text-center">
			<>
				<CardFactory
					service={service}
					data={data as CardData}
					printMode={printMode}
				/>
				{printMode && (
					<div className="flex justify-center print:hidden">
						<Button
							className="border-none py-3 px-10 text-font-cta text-lg bg-cta md:hover:bg-cta-hover active:bg-cta-hover focus:bg-cta-hover disabled:bg-cta-disabled  disabled:hover:bg-cta-disabled inline-flex justify-center cursor-pointer rounded-full font-semibold whitespace-nowrap mx-auto px-6"
							onClick={onPrint}
							analytics={{
								eventType: EventType.SimpleEvent,
								eventCategory: EventCategory.Confirmation,
								eventLabel: EventLabel?.Click,
								eventAction: t('pages.confirmation.print.modalButton'),
								userActionType: UserActionType.click,
								eventArgs: {},
							}}>
							<span className="mr-2.5">
								<PrintIcon className="fill-current" />
							</span>
							{t('pages.confirmation.print.modalButton')}
						</Button>
					</div>
				)}
				{!printMode && (
					<div className="flex flex-col gap-8">
						{ServiceNames.copay === service.name && (
							<DigitalWallet walletKey={data.digitalWalletKey} />
						)}
						<div className="flex justify-center">
							<Button
								onClick={openPrint}
								analytics={{
									eventType: EventType.SimpleEvent,
									eventCategory: EventCategory?.Confirmation,
									eventLabel: EventLabel?.Click,
									userActionType: UserActionType.click,
									eventArgs: {},
								}}>
								{t('pages.confirmation.print.button')}
							</Button>
						</div>
					</div>
				)}
				<div className="text-sm text-font text-left max-w-none prose [&_h3]:text-font [&_h3]:text-lg [&_h3]:mb-2.5 [&_p]:text-sm print:text-font">
					<Terms service={service} />
				</div>
			</>
		</Section>
	);
};

export default CardConfirmed;
